import { render, staticRenderFns } from "./GoodsCard.vue?vue&type=template&id=2608667d&scoped=true&"
import script from "./GoodsCard.vue?vue&type=script&lang=js&"
export * from "./GoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCard.vue?vue&type=style&index=0&id=2608667d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608667d",
  null
  
)

export default component.exports